import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import MarketingNav from '../components/marketing/MarketingNav';

// Import marketing pages
import CampaignList from '../pages/marketing/CampaignList';
import CampaignEditor from '../pages/marketing/CampaignEditor';
import CampaignStats from '../pages/marketing/CampaignStats';
import ContactList from '../pages/marketing/ContactList';
import ContactEditor from '../pages/marketing/ContactEditor';
import ListManager from '../pages/marketing/ListManager';
import MarketingSettings from '../pages/marketing/MarketingSettings';
import Unsubscribe from '../pages/marketing/Unsubscribe';

/**
 * Marketing module routes for the email marketing system
 */
const MarketingRoutes = () => {
  return (
    <Box>
      <MarketingNav />
      <Box sx={{ p: 3 }}>
        <Routes>
          {/* Campaign routes */}
          <Route index element={<CampaignList />} />
          <Route path="campaigns" element={<CampaignList />} />
          <Route path="campaigns/create" element={<CampaignEditor />} />
          <Route path="campaigns/edit/:id" element={<CampaignEditor />} />
          <Route path="campaigns/stats/:id" element={<CampaignStats />} />
          
          {/* Contact routes */}
          <Route path="contacts" element={<ContactList />} />
          <Route path="contacts/create" element={<ContactEditor />} />
          <Route path="contacts/edit/:id" element={<ContactEditor />} />
          
          {/* List routes */}
          <Route path="lists" element={<ListManager />} />
          
          {/* Settings route */}
          <Route path="settings" element={<MarketingSettings />} />
          
          {/* Public routes */}
          <Route path="unsubscribe" element={<Unsubscribe />} />
          
          {/* Default route */}
          <Route path="*" element={<CampaignList />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default MarketingRoutes; 